import React, { useEffect, useState } from "react";
import Dashboard from "../../components/Dashboard/Dashboard";
import rate from "../../components/assets/rate.png";
import { Dropdown } from "react-bootstrap";
import { CryptoItems } from "../Trade/CryptoItems";
import Logo from "../../components/assets/logo long.svg";
import moment from "moment"
import "./Home.css";
import Tracker from "../../components/Tracker"
export default function Home(props) {
  const [selectedItem, setSelectedItem] = useState(0);
  const [fetchingData, setFetchingData] = useState(false);
  const [data, setData] = useState(null);
  const [crypto,setCrypto] = useState("BTC")
  useEffect(() => {
    const abortController = new AbortController()
    const signal = abortController.signal
    const getData = () => {
      const url = `https://min-api.cryptocompare.com/data/histohour?fsym=${crypto}&tsym=USD&limit=30`;

      fetch(url,{signal:signal}).then( r => r.json())
        .then((cryptoprice) => {
          const sortedData = [];
          let count = 0;
         
          for (let date in cryptoprice.Data){       
            sortedData.push({
              d: moment(cryptoprice.Data[date].time*1000).format('MMM DD YYYY'),
              p: cryptoprice.Data[date].close.toLocaleString('us-EN',{ style: 'currency', currency: 'USD' }),
              x: count, 
              y: cryptoprice.Data[date].close
            });
            count++;
          }
          // console.log(sortedData)
            setData(sortedData)
            setFetchingData(false)
        })
        .catch((e) => {
          console.log(e);
        });
    }
    getData();
    return () => abortController.abort()
  }, [crypto]);
  const changeIndex = (index) => {
    setFetchingData(false)
    setSelectedItem(index);
    setCrypto(CryptoItems[index].short)
  };

  return (
    <Dashboard {...props} back={()=>null}>
      <div className="d-flex">
        <div className="d-flex mr-3 align-items-center">
          <p className="blueText fs-24 my-auto mr-3">Today's rates</p>
          <img alt="" src={rate} />
        </div>
        <div>
          <Dropdown>
            <Dropdown.Toggle
              drop="down"
              className="border-0 bts-sales-button blueText"
              id="dropdown-basic"
            >
              <img
                height="18px"
                alt=""
                className="mr-2"
                width="30px"
                src={CryptoItems[selectedItem].img}
              />
              {CryptoItems[selectedItem].short}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {CryptoItems.filter((item) => item.srate !== "Coming soon").map(
                (item, i) => (
                  <Dropdown.Item
                    eventKey="1"
                    key={i}
                    onClick={() => changeIndex(i)}
                  >
                    <img height="16px" alt="" width="24px" src={item.img} />
                    {item.short}
                  </Dropdown.Item>
                )
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
        <div className="w-100 mh-200 d-flex align-items-center py-4">
           {data ? <Tracker data={data} fetchingData={fetchingData} /> : <div className="d-flex justify-content-center w-100 align-items-center"><img src={Logo} alt="Bitmasta" />
           </div>
           }
        </div>
    </Dashboard>
  );
}
